import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import { ServicesGrid } from './components/Services';
import WhyChoose from './components/WhyChoose';
import HowItWorks from './components/HowItWorks';
import RequestSection from './components/RequestSection';
import { Gallery, Testimonials } from './components/SocialProof';
import Faq from './components/Faq';
import Footer, { CtaBand } from './components/Footer';
import CrmApp from './crm/CrmApp';
import ReviewPage from './crm/ReviewPage';

function App() {
  const path = window.location.pathname.replace(/\/+$/, '');
  if (path === '/webmail') {
    window.location.replace('https://webmail.hostverge.com');
    return null;
  }

  if (path === '/admin' || window.location.hash === '#/admin') {
    if (window.location.hash === '#/admin') window.history.replaceState(null, '', '/admin');
    return <CrmApp />;
  }

  if (path === '/review') return <ReviewPage />;

  return (
    <>
      <Header />
      <main>
        <Hero />
        <ServicesGrid />
        <WhyChoose />
        <HowItWorks />
        <RequestSection />
        <Gallery />
        <Testimonials />
        <Faq />
        <CtaBand />
      </main>
      <Footer />
    </>
  );
}

export default App;